import authProvider from "./auth/authProvider";
import DashboardProvider from "./dashboard/dashboardProvider";
import GlobalLoaderProvider from "./globalLoader/globalLoaderProvider";
import ProductCategoryProvider from "./productCategory/productCategoryProvider";
import UserProvider from "./Users/userProvider";
import QuestionnaireProvider from "./questionnaire/questionnaireProvider";
import NotificationsProvider from "./notifications/notificationsProvider";
import AuditProvider from "./ManageAudit/AuditProvider"
import RemoteAuditProvider from "./remoteAudit/remoteAuditProvider";
import ConversationProvider from "./coversation/coversationProvider";
// Import other created Providers and add them here -

const providers = [
  authProvider,
  DashboardProvider,
  ProductCategoryProvider,
  UserProvider,
  QuestionnaireProvider,
  GlobalLoaderProvider,
  NotificationsProvider,
  AuditProvider,
  RemoteAuditProvider,
  ConversationProvider
];

const combineProviders = (components) => {
  return components.reduce(
    (AccumulatedComponents, CurrentComponent) => {
      return ({ children }) => {
        return (
          <AccumulatedComponents>
            <CurrentComponent>{children}</CurrentComponent>
          </AccumulatedComponents>
        );
      };
    },
    ({ children }) => <>{children}</>
  );
};

// Combining multiple providers to single provider - this will be wrapped around App.js
export default combineProviders(providers);
